import { render, staticRenderFns } from "./ChatBoxTelegram.vue?vue&type=template&id=2e6b7ad8&"
import script from "./ChatBoxTelegram.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports